/**
 * Cosumy Auto Gift - Quick Fix Version (Live Cart Data)
 */

class CosumyAutoGiftQuickFix {
  constructor() {
    this.GIFT_THRESHOLD_CENTS = 7900; // 79.00€ in cents
    this.GIFT_SKU = '7770201';
    this.giftVariantId = null;
    this.isProcessing = false;
    this.hasInitialized = false;

    console.log('🎁 Auto Gift: Live Data Version Starting');
    console.log(`🎁 Gift threshold: ${this.GIFT_THRESHOLD_CENTS / 100}€`);

    this.init();
  }

  async init() {
    if (this.hasInitialized) return;
    this.hasInitialized = true;

    await this.findGiftVariant();

    if (!this.giftVariantId) {
      console.error('🎁 ERROR: Gift variant not found - system disabled');
      return;
    }

    console.log('🎁 ✅ Gift variant found:', this.giftVariantId);
    this.startMonitoring();
  }

  async findGiftVariant() {
    try {
      const res = await fetch('/products.json?limit=250');
      const data = await res.json();

      for (const product of data.products) {
        const variant = product.variants.find(v => v.sku === this.GIFT_SKU);
        if (variant && variant.available) {
          this.giftVariantId = variant.id;
          return;
        }
      }
    } catch (error) {
      console.error('🎁 ❌ Error finding gift variant:', error);
    }
  }

  startMonitoring() {
    // First check after 1s
    setTimeout(() => this.checkAndManageGift(), 1000);
    // Then check every 3s
    setInterval(() => this.checkAndManageGift(), 3000);
  }

  async checkAndManageGift() {
    if (this.isProcessing) return;

    try {
      const cart = await this.getLiveCart();
      const qualifies = cart.total_price >= this.GIFT_THRESHOLD_CENTS;
      const giftLine = cart.items.find(item => item.id == this.giftVariantId && this.isAutoGiftFromProps(item));

      console.log(`🎁 vatii Cart total: €${(cart.total_price / 100).toFixed(2)}`, qualifies ? '(Eligible)' : '(Not eligible)');

      if (qualifies && !giftLine) {
        await this.addGift();
      } else if (!qualifies && giftLine) {
        await this.removeAllGifts();
      }
    } catch (error) {
      console.error('🎁 ❌ Error checking gift status:', error);
    }
  }

  async getLiveCart() {
    const res = await fetch('/cart.js');
    return res.json();
  }

  isAutoGiftFromProps(item) {
    return item.properties && (item.properties._auto_added === 'true' || item.properties._gift);
  }

  async addGift() {
    if (this.isProcessing) return;
    this.isProcessing = true;
    console.log('🎁 ➕ Adding gift to cart...');

    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{
            id: this.giftVariantId,
            quantity: 1,
            properties: {
              '_gift': 'Geschenk ab 79€',
              '_auto_added': 'true'
            }
          }]
        })
      });
      console.log('🎁 Gift added successfully');
     
    } catch (error) {
      console.error('🎁 ❌ Error adding gift:', error);
    } finally {
      this.isProcessing = false;
       this.refreshCartSections();
    }
  }

  async removeAllGifts() {
    if (this.isProcessing) return;
    this.isProcessing = true;
    console.log('🎁 🗑️ Removing gift from cart...');

    try {
      const cart = await this.getLiveCart();
      for (let i = 0; i < cart.items.length; i++) {
        const item = cart.items[i];
        if (item.id == this.giftVariantId && this.isAutoGiftFromProps(item)) {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ line: i + 1, quantity: 0 })
          });
        }
      }
      console.log('🎁 Gift removed successfully');
     
    } catch (error) {
      console.error('🎁 ❌ Error removing gift:', error);
    } finally {
      this.isProcessing = false;
      this.refreshCartSections();
    }
  }





async refreshCartSections() {
  const sectionsToRender = [
    {
      id: 'CartDrawer',
      section: 'cart-drawer' // This must match your section file name in /sections
    }
  ];

  const url = `/cart?sections=${sectionsToRender.map(s => s.section).join(',')}`;

  fetch(url)
    .then(res => res.json())
    .then(data => {
      sectionsToRender.forEach(({ id, section }) => {
        const container = document.getElementById(id);
        if (container && data[section]) {
          container.innerHTML = new DOMParser()
            .parseFromString(data[section], 'text/html')
            .getElementById(id).innerHTML;
        }
      });
    })
    .catch(err => console.error('Cart Drawer refresh failed:', err));
}








}

function startQuickFixGiftSystem() {
  if (!window.quickFixGiftSystemStarted) {
    window.quickFixGiftSystemStarted = true;
    new CosumyAutoGiftQuickFix();
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', startQuickFixGiftSystem);
} else {
  setTimeout(startQuickFixGiftSystem, 500);
}



